import React from 'react';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import Header from '../organisms/Header';
import Footer from '../organisms/Footer';
import FooterWithContents from '../organisms/FooterWithContents';
import SEO from '../SEO';

const AppMain = (props) => {
  const { Component, pageProps, isAppLoading } = props;
  const router = useRouter();
  const { locale: currentLocale } = router;

  const renderFooter = () => {
    if (currentLocale === 'ja') {
      return <FooterWithContents />;
    } else {
      return <Footer />;
    }
  };

  const appWrapperClass = classnames({ loading: isAppLoading });
  return (
    <div id="app-wrapper" className={appWrapperClass}>
      <SEO />
      <Header />
      <Component {...pageProps} />
      {renderFooter()}
    </div>
  );
};

export default AppMain;
